import {useEffect} from "react";
import { setAppVersion, useUiStore } from '@/stores/ui.store.ts';
import { useLocation } from '@tanstack/react-router';

export function useVersionReload() {
  const appVersion = useUiStore(state => state.appVersion);
  const location = useLocation();
  useEffect(() => {
    try {
      const now = new Date();
      if (appVersion) {
        const versionDate = new Date(appVersion);
        const minutesToLive = 5;
        const diffMinutes = (now.getTime() - versionDate.getTime()) / (1000 * 60);
        if (diffMinutes < minutesToLive) {
          // If the app version was set less than 5 minutes ago, skip the check
          return;
        }
        // console.log({appVersion, versionDate, diffMinutes, minutesToLive})
      }
      fetch('/version.json?v=' + now.getTime()).then(r => r.json()).then(data => {
        const timestamp = data?.timestamp || '';
        if (appVersion && timestamp && timestamp !== appVersion) {
          window.location.reload();
        } else {
          setAppVersion(timestamp);
        }
      });
    } catch (err) {
      console.error('Error fetching version.json', err);
    }
  }, [location.pathname]);
}